import { render, staticRenderFns } from "./dentistryOne.vue?vue&type=template&id=df648f82&scoped=true"
import script from "./dentistryOne.vue?vue&type=script&lang=js"
export * from "./dentistryOne.vue?vue&type=script&lang=js"
import style0 from "./dentistryOne.vue?vue&type=style&index=0&id=df648f82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df648f82",
  null
  
)

export default component.exports